import { IfcDiffOverviewDialog } from "@/domains/buildings/components/ifc-viewer/diff/IfcDiffOverviewDialog";
import { PdfCompareDialog } from "@/domains/documents/components/PdfCompareDialog";
import { observer } from "mobx-react-lite";
import type { DocumentTablePresentation } from "./documentTablePresentation";
export const TablePdfCompareDialog = observer(function TablePdfCompareDialog(
  props: DocumentTablePresentation
) {
  const { compareDocuments, compareOpen, setCompareOpen } = props;
  return (
    <PdfCompareDialog
      documentA={compareDocuments.docA}
      documentB={compareDocuments.docB}
      open={compareOpen}
      onOpenChange={setCompareOpen}
    />
  );
});

export const TableIfcCompareDialog = observer(function TableIfcCompareDialog(
  props: DocumentTablePresentation
) {
  const { diffOverview, closeDiffOverview } = props;
  return (
    diffOverview && (
      <IfcDiffOverviewDialog
        open
        onOpenChange={(open) => {
          if (!open) closeDiffOverview();
        }}
        baseDocId={diffOverview.baseDocId}
        targetDocId={diffOverview.targetDocId}
        baseFilename={diffOverview.baseFilename}
        baseVersion={diffOverview.baseVersion}
        targetFilename={diffOverview.targetFilename}
        targetVersion={diffOverview.targetVersion}
        buildingId={diffOverview.buildingId}
      />
    )
  );
});
